import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageSwitcherStore } from '@libs/mtjr/shared/i18n/language-switcher.store';

export const clientInfoInterceptor: HttpInterceptorFn = (req, next) => {
  const languageStore = inject(LanguageSwitcherStore);
  const lang = languageStore.currentLang()?.code || 'en';

  const modifiedReq = req.clone({
    setHeaders: { lang: lang },
  });

  return next(modifiedReq);
};
